import React from "react";
import { AuthConsumer } from "../../providers/AuthProvider";
import Loader from "../../components/loader";

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <Loader />;
        }}
    </AuthConsumer>
);